import { GridItem, LayoutGrid } from '@jouzen/ecom-components';
import { useState } from 'react';
import type { MessageKey } from 'types/LocaleMessageKey';

import CompareModelsModal from '@/app/components/CompareModelsModal';
import ArtDirectionImage, {
  type ArtDirectionImageProps,
} from '@/app/components/Image/ArtDirectionImage';
import Motion from '@/app/components/Motion';

import PopCompareModelsContent from './PopCompareModelsContent';

export interface PopCompareModelsProps {
  readonly copy: MessageKey;
  readonly image: Pick<ArtDirectionImageProps, 'localizedAlt' | 'srcSet'>;
  readonly onCtaClick?: () => void;
  readonly title: MessageKey;
}

const PopCompareModels = ({
  copy,
  image,
  onCtaClick,
  title,
}: PopCompareModelsProps) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  const toggleModal = () => {
    setModalOpen((_modalOpen) => !_modalOpen);
  };

  const handleCtaClick = () => {
    onCtaClick?.();
    toggleModal();
  };

  return (
    <>
      <section className="pb-20" data-cy="pop-compare-models-section">
        <LayoutGrid rowGap={48}>
          <GridItem
            colEnd={{ sm: 'main' }}
            colStart={{ sm: 'main', lg: 12, xxl: 11 }}
            rowEnd={{ sm: 2 }}
            rowStart={{ sm: 1 }}
          >
            <div className="flex h-full flex-col justify-center">
              <Motion
                initial={{ filter: 'blur(5px)', opacity: 0 }}
                transition={{ delay: 0.25, duration: 0.75, type: 'tween' }}
                viewport={{ once: true }}
                whileInView={{ filter: 'blur(0px)', opacity: 1 }}
              >
                <div className="relative overflow-hidden rounded-lg max-md:h-80 md:aspect-2/1 lg:rounded-2xl">
                  <ArtDirectionImage className="object-cover" fill {...image} />
                </div>
              </Motion>
            </div>
          </GridItem>
          <GridItem
            colEnd={{ sm: 'main', lg: 11, xl: 10 }}
            colStart={{ sm: 'main' }}
            rowEnd={{ sm: 3, lg: 2 }}
            rowStart={{ sm: 2, lg: 1 }}
          >
            <PopCompareModelsContent
              copy={copy}
              onCtaClick={handleCtaClick}
              title={title}
            />
          </GridItem>
        </LayoutGrid>
      </section>
      <CompareModelsModal isOpen={modalOpen} toggleModal={toggleModal} />
    </>
  );
};

export default PopCompareModels;
